import { styled, Tooltip, tooltipClasses, TooltipProps } from "@mui/material";
import {
  GridColDef,
  GridEditCellProps,
  GridEditInputCell,
  GridPreProcessEditCellProps,
  GridRenderEditCellParams,
} from "@mui/x-data-grid";
import { useIntl } from "react-intl";
import { validateCalculationField } from 'features/Mobile/utils';
interface InputTextDefProps {
  field: string;
  headerName: string;
  width: number;
  editable: boolean;
  errorMessageType: string;
  preProcessEditCellProps?: (params: GridPreProcessEditCellProps) => GridEditCellProps;
}

const SUB_HEADING_MAX_LENGTH = 26;

const StyledTooltip = styled(({ className, ...props }: TooltipProps) => (
  <Tooltip {...props} classes={{ popper: className }}/>
))(({ theme }) => ({
  [`& .${tooltipClasses.tooltip}`]: {
    backgroundColor: theme.palette.error.main,
    color: theme.palette.error.contrastText,
  },
}));

const InvalidEditCell = (params: GridRenderEditCellParams) => {
  const { error } = params;
  const intl = useIntl();

  return (
    <StyledTooltip open={!!error} title={intl.formatMessage({ id: 'app.error.invalid' })}>
        <div>
            <GridEditInputCell {...params}/>
        </div>
    </StyledTooltip>
  );
};

const SubHeadingMaxLengthEditCell = (params: GridRenderEditCellParams) => {
  const { error } = params;
  const intl = useIntl();

  return (
    <StyledTooltip open={!!error} title={intl.formatMessage({ id: 'app.error.subHeadingMaxLength' }, { maxLength: SUB_HEADING_MAX_LENGTH })}>
        <div>
            <GridEditInputCell {...params}/>
        </div>
    </StyledTooltip>
  );
};

export const validateSubHeading = (params: GridPreProcessEditCellProps) => {
  const value: string = String(params.props.value);
  const valid = value.length <= SUB_HEADING_MAX_LENGTH;
  return { ...params.props, error: !valid};
}

export const validateCalculation = (params: GridPreProcessEditCellProps) => {
  const value: string = String(params.props.value);
  const valid = validateCalculationField(value);
  return { ...params.props, error: !valid};
};

export function generateInputTextDef({
  field,
  headerName,
  width,
  editable,
  errorMessageType,
  preProcessEditCellProps,
}: InputTextDefProps): GridColDef {
  return {
    field,
    headerName,
    width,
    editable,
    preProcessEditCellProps: preProcessEditCellProps,
    ...(errorMessageType === "INVALID" ? {renderEditCell: InvalidEditCell} : {renderEditCell: SubHeadingMaxLengthEditCell})
  };
}
